import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, Form } from 'reactstrap'
import LabelStatusPanel from './LabelStatusPanel'

class ShipSearch extends React.Component {
    state = {
        barcode: '',
    }

    _handleSubmit = (e) => {
        e.preventDefault()

        const { onSubmit } = this.props
        const { barcode } = this.state
        const vBarcode = (barcode || '').trim()

        if (!vBarcode) return false

        this.setState({
            barcode: ''
        }, () => {
            typeof onSubmit === 'function' && onSubmit(vBarcode)
        })
    }

    _handleChangeInput = (e) => {
        const { value } = e.target

        this.setState({
            barcode: value,
        })
    }

    render() {
        const { barcode } = this.state
        const { status, item } = this.props
        const { tags = [] } = { ...item }

        return (
            <div className='PrintSearch'>
                <Card>
                    <div className="card-header bg-success text-white header-elements-inline justify-content-start flex-wrap">
                        <h1 className="card-title mr-5">Dán Label - Quét hoặc nhập mã QR</h1>
                        {tags.includes('cap_product') &&
                            <span className="capTag mr-3">Sản phẩm Mũ</span>
                        }
                        {tags.includes('made_vn') &&
                            <span className="tagVN mr-3">Made in VN</span>
                        }
                        {tags.includes('photo_requested') &&
                            <span className="photo_request mr-3">CHỤP ẢNH</span>
                        }
                    </div>
                    <CardBody>
                        <div className="ShipSearchBody">
                            <Form className='d-flex justify-content-center' onSubmit={this._handleSubmit}>
                                <input
                                    className='InputSearch form-control'
                                    name='barcodeNumber'
                                    value={barcode}
                                    onChange={this._handleChangeInput}
                                    autoFocus
                                />

                                {
                                    !!status &&
                                    <div className="Status">{status}</div>
                                }
                            </Form>

                            {/* FAC-23754: preview label / cảnh báo "Chưa có label" khi scan item đầu tiên */}
                            <LabelStatusPanel item={item} />
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

ShipSearch.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    status: PropTypes.any,
}

export default ShipSearch
